/**
 * 头部导航组件
 * zxw
 * 创建时间：2023-03-07
 * 修改时间：2026-01-31
 */

import {
    QuestionOutlined,
    LogoutOutlined,
    SettingOutlined,
} from '@ant-design/icons';
import {
    Layout,
    theme,
    Row,
    Col,
    Dropdown,
    Avatar,
    Button,
    message,
    Typography,
} from 'antd';
import cookie from 'react-cookies';
import CNF from '../incs/Config';
import { DeleteCookies } from '../incs/FunHelper';
import YNavService from './YNavService';

const { Header } = Layout;
const { Text } = Typography;

const onClick = (e) => {
    if (e.key === '1') {
        window.location.href = CNF.userUrl;
    }
    if (e.key === '2') {
        message.info('正在努力开发中......');
    }
    if (e.key === '3') {
        // 退出登录
        DeleteCookies()
    }
}

const YHeader = (props) => {
    const {
        token: {
            colorPrimary,
            colorBgBase,
        },
    } = theme.useToken();

    const items = [
        {
            key: '1',
            label: <Button icon={<SettingOutlined />} style={{ color: CNF.baseFontColor }} color='default' variant='link'>设置</Button>,
        },
        {
            key: '2',
            label: <Button icon={<QuestionOutlined />} style={{ color: CNF.baseFontColor }} color='default' variant='link'>帮助</Button>,
        }, {
            key: '3',
            label: <Button icon={<LogoutOutlined />} style={{ color: CNF.baseFontColor }} color='default' variant='link'>退出</Button>,
        }
    ]
    return (
        <>
            <Header style={{
                padding: 0,
                height: `${CNF.menuHeight}px`,
                background: colorBgBase,
                alignItems: 'center',
            }}>
                <Row justify='end'>
                    {
                        props.navLists.length > 0 && props.navLists.map((item) => {
                            return <Col key={item.name} span={1}>
                                <Button color='primary' variant='link' href={item.url} target='_blank' rel='noopener noreferrer' title={item.name}>{item.name}</Button>
                            </Col>
                        })
                    }
                    <Col span={1}></Col>
                    <Col span={4}>
                        <YNavService
                            setThemeColor={props.setThemeColor}
                            isCompact={props.isCompact}
                            setIsCompact={props.setIsCompact}
                            isDarkMode={props.isDarkMode}
                            setIsDarkMode={props.setIsDarkMode}
                        />
                    </Col>
                    <Col span={2}><Text>简体中文</Text></Col>
                    <Col span={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: CNF.searchMarginLeft * 4, }}>
                        <Dropdown menu={{ items, onClick }}>
                            <Button type='link'>
                                {
                                    cookie.load(CNF.cookies.keyAvatarUrl) ? (
                                        <Avatar
                                            size='middle'
                                            src={cookie.load(CNF.cookies.keyAvatarUrl) ? CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl) : ''}
                                        />
                                    ) : (
                                        <Avatar
                                            style={{
                                                verticalAlign: 'middle',
                                                backgroundColor: colorPrimary,
                                            }}
                                            size='middle'
                                        >
                                            {cookie.load(CNF.cookies.keyId) ? cookie.load(CNF.cookies.keyId).substr(0, 1).toUpperCase() : 'U'}
                                        </Avatar>
                                    )
                                }
                            </Button>
                        </Dropdown>
                    </Col>
                </Row>
            </Header >
        </>
    )
}

export default YHeader